import { Grid, GridAreas } from '@dreryk/react-components';

import { BuildingField } from '../../../components/BuildingField';
import { CountryField } from '../../../components/CountryField';
import { FlatField } from '../../../components/FlatField';
import { PostcodeField } from '../../../components/PostcodeField';
import { StreetField } from '../../../components/StreetField';
import { TownField } from '../../../components/TownField';
import { InvoiceCreateFormRegisterControllerProp } from '../InvoiceCreateForm.types';

type ADDRESS_FIRST_LINE_GRID_AREA = 'country' | 'town' | 'postcode';
type ADDRESS_SECOND_LINE_GRID_AREA = 'street' | 'building' | 'flat';

const ADDRESS_FIRST_LINE_GRID_COLUMNS = 3;
const ADDRESS_SECOND_LINE_GRID_COLUMNS = 3;
const GRID_GAP = '24px 36px';

const ADDRESS_FIRST_LINE_GRID_AREAS: GridAreas<ADDRESS_FIRST_LINE_GRID_AREA, typeof ADDRESS_FIRST_LINE_GRID_COLUMNS> = {
   custom: {
      template: ['country town postcode', '. . .'],
      gridTemplateColumns: '308px 308px 128px',
      gap: GRID_GAP,
   },
};

const ADDRESS_SECOND_LINE_GRID_AREAS: GridAreas<
   ADDRESS_SECOND_LINE_GRID_AREA,
   typeof ADDRESS_SECOND_LINE_GRID_COLUMNS
> = {
   custom: {
      template: ['street building flat'],
      gridTemplateColumns: '308px 128px 128px',
      gap: GRID_GAP,
   },
};

type InvoiceCreateFormAddressSectionProps = InvoiceCreateFormRegisterControllerProp & {
   readonly countryIsoCode: string | undefined;
   readonly countryFieldDisabled?: boolean;
};

export const InvoiceCreateFormAddressSection = (props: InvoiceCreateFormAddressSectionProps): JSX.Element => {
   const { countryIsoCode, countryFieldDisabled, register } = props;

   return (
      <section>
         <Grid<ADDRESS_FIRST_LINE_GRID_AREA, typeof ADDRESS_FIRST_LINE_GRID_COLUMNS>
            areas={ADDRESS_FIRST_LINE_GRID_AREAS}
            testId={'addressFirstLineGrid'}
            country={<CountryField register={register} disabled={countryFieldDisabled} />}
            postcode={<PostcodeField register={register} countryIsoCode={countryIsoCode} />}
            town={<TownField register={register} />}
         />
         <Grid<ADDRESS_SECOND_LINE_GRID_AREA, typeof ADDRESS_SECOND_LINE_GRID_COLUMNS>
            areas={ADDRESS_SECOND_LINE_GRID_AREAS}
            testId={'addressSecondLineGrid'}
            building={<BuildingField register={register} />}
            flat={<FlatField register={register} />}
            street={<StreetField register={register} required />}
         />
      </section>
   );
};
